import { useEffect, useState } from "react";
import { toast } from "sonner";
import { Loader2 } from "lucide-react";
import { api, errMsg, todayRome } from "@/lib/api";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from "@/components/ui/dialog";
import { Input } from "@/components/ui/input";
import { Button } from "@/components/ui/button";
import { Field, NativeSelect } from "@/components/common";

export const METODI = ["Contanti", "Carta / Bancomat", "Bonifico", "Klarna", "Altro"];

export const PayDialog = ({ ddt, open, onOpenChange, onSaved }) => {
  const [f, setF] = useState({ pagato_data: todayRome(), pagato_metodo: "Contanti", importo: "" });
  const [busy, setBusy] = useState(false);
  useEffect(() => { if (open && ddt) setF({ pagato_data: ddt.pagato_data || todayRome(), pagato_metodo: ddt.pagato_metodo || "Contanti", importo: ddt.totale_servizio || "" }); }, [open, ddt]);

  const save = async (pagato) => {
    setBusy(true);
    try {
      const { data } = await api.patch(`/admin/ddts/${ddt.id}/pagamento`, { pagato, pagato_data: f.pagato_data, pagato_metodo: f.pagato_metodo, importo: f.importo === "" ? null : Number(f.importo) });
      toast.success(pagato ? "Pagamento registrato: DDT, pratica e contabilità aggiornati" : "Pagamento annullato");
      onSaved?.(data); onOpenChange(false);
    } catch (e) { toast.error(errMsg(e)); } finally { setBusy(false); }
  };

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="max-w-md bg-[#FAF8F5]" data-testid="pay-dialog">
        <DialogHeader>
          <DialogTitle className="font-display text-2xl text-[#0D3B52]">Pagamento DDT n. {ddt?.numero}</DialogTitle>
          <DialogDescription>Indica quando e come ha pagato il cliente: aggiorno il DDT, la pratica e la contabilità.</DialogDescription>
        </DialogHeader>
        <div className="grid grid-cols-2 gap-4">
          <Field label="Data pagamento"><Input type="date" value={f.pagato_data} onChange={(e) => setF({ ...f, pagato_data: e.target.value })} className="bg-white" data-testid="pay-date" /></Field>
          <Field label="Metodo">
            <NativeSelect value={f.pagato_metodo} onChange={(e) => setF({ ...f, pagato_metodo: e.target.value })} data-testid="pay-method">
              {METODI.map((m) => <option key={m}>{m}</option>)}
            </NativeSelect>
          </Field>
          <Field label="Totale servizio € (IVA incl.)" className="col-span-2"><Input type="number" step="0.01" value={f.importo} onChange={(e) => setF({ ...f, importo: e.target.value })} className="bg-white" data-testid="pay-amount" /></Field>
        </div>
        <div className="flex justify-between gap-2">
          {ddt?.pagato && <Button variant="outline" onClick={() => save(false)} disabled={busy} data-testid="pay-undo">Segna come non pagato</Button>}
          <Button onClick={() => save(true)} disabled={busy} data-testid="pay-confirm" className="ml-auto rounded-full bg-emerald-700 hover:bg-emerald-800">{busy ? <Loader2 className="h-4 w-4 animate-spin" /> : "Conferma pagamento"}</Button>
        </div>
      </DialogContent>
    </Dialog>
  );
};
